<template>
	<div class="auth-main">
		<el-form ref="loginForm" :model="loginData" :rules="rules" v-if="isHidden">
			<el-form-item class="input-item" prop="account">
				<el-input class="login-input" v-model="loginData.account" placeholder="手机号" prefix-icon="iconfont el-icon-user"></el-input>
			</el-form-item>
			<el-form-item class="input-item" prop="password">
				<el-input class="login-input" type="password" v-model="loginData.password" placeholder="密码" prefix-icon="iconfont icon-lock"></el-input>
			</el-form-item>
			<el-form-item class="input-item" style="margin-bottom: 5px !important; margin-top: -12px">
				<SmartCaptcha ref="smartCaptchaRef" @verifySuccess="verifySuccess"></SmartCaptcha>
			</el-form-item>
			<el-form-item><CommonButton :buttonTitle="pwdTiltle" :isDisable="pwdIsDisable" class="login-button" :type="'primary'" @buttonClick="handlerLogin" /></el-form-item>
			<el-button type="text" class="login-way" @click="loginAccount">短信验证码登录</el-button>
		</el-form>

		<el-form ref="loginFormTel" :model="telLoginData" :rules="rulesTel" v-else>
			<el-form-item class="input-item" prop="telephone">
				<el-input placeholder="请输入手机号" type="text" class="login-input" v-model="telLoginData.telephone">
					<template slot="prepend">
						+86
					</template>
				</el-input>
			</el-form-item>
			<el-form-item class="input-item" prop="registerCode">
				<el-input placeholder="短信验证码" type="text" class="login-input" v-model="telLoginData.registerCode">
					<template slot="append">
						<div>
							<el-button class="get-register" :disabled="!telLoginData.telephone || phoneCode !== '获取验证码'" @click="getVerifiCode">{{ phoneCode }}</el-button>
						</div>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item class="input-item" style="margin-bottom: 5px !important; margin-top: -12px">
				<SmartCaptcha ref="smartCaptchaRef" @verifySuccess="verifySuccess"></SmartCaptcha>
			</el-form-item>
			<el-form-item><CommonButton :buttonTitle="pwdTiltle" :isDisable="telLogin" class="login-button" :type="'primary'" @buttonClick="handlerLogin" /></el-form-item>
			<el-button v-if="isShowAccountLogin" type="text" class="login-way" @click="loginTel">用户名密码登录</el-button>
		</el-form>

		<el-dialog :visible.sync="dialogVisible" width="30%" top="45vh" :show-close="false" :center="true">
			<div class="slide"><SlideCaptcha ref="slideCaptchaRef" @slideVerify="slideVerify"></SlideCaptcha></div>
		</el-dialog>
	</div>
</template>

<script>
import { mapMutations } from 'vuex';
import CommonButton from '@/components/CommonButton';

import SmartCaptcha from '../../components/captchas/SmartCaptcha';
import SlideCaptcha from '../../components/captchas/SlideCaptcha';
export default {
	components: {
		CommonButton,
		SmartCaptcha,
		SlideCaptcha
	},
	data() {
		return {
			isShowAccountLogin:true,
			phoneCode: '获取验证码',
			timer: null,
			dialogVisible: false,
			//  默认是 密码登录，当点击获取验证码，滑动验证通过后，修改为 短信登录， 点击登录按钮时判断 loginType,发送不同的数据请求
			loginType: 'password', // password, sms
			slideScene: 'nc_message', //  滑动验证的 scene
			smartScene: 'ic_login', //  智能验证的 scene

			Verified: '',
			title: '',
			pwdIsDisable: false,
			telIsDisable: false,
			telLogin: false,
			pwdTiltle: '登录',
			wait: 0,
			activeName: 'login1',
			isVisible: false,
			isHidden: true,
			mobile: '18940981399',
			codeText: '获取验证码',
			loginData: {
				account: '',
				password: '',
				authenticate: '',
				token: ''
			},
			//手机登录数据
			telLoginData: {
				telephone: '',
				registerCode: ''
			},
			//手机号登录表单验证
			rulesTel: {
				telephone: [{ required: true, message: '输入手机号', trigger: 'blur' }, { max: 11, message: '请输入11位手机号' }],
				registerCode: [{ required: true, message: '输入短信验证码', trigger: 'blur' }]
			},
			// 表单验证
			rules: {
				account: [{ required: true, message: '输入手机号', trigger: 'blur' }],
				password: [{ required: true, message: '输入密码', trigger: 'blur' }]
			}
		};
	},
	methods: {
		...mapMutations(['handleUserInfo']),
		smsCountDown() {
			let count = 60;
			this.timer = setInterval(() => {
				if (count > 0 && count <= 60) {
					count--;
					this.phoneCode = `${count}秒重新发送`;
				} else {
					clearInterval(this.timer);
					this.timer = null;
					this.phoneCode = '获取验证码';
				}
			}, 1000);
		},
		async slideVerify(value) {
			if (value) {
				this.dialogVisible = false;
				this.telLoginData.sessionId = value.sessionId;
				this.telLoginData.token = value.token;
				this.telLoginData.sig = value.sig;
				this.telLoginData.scene = this.slideScene;
				try {
					let result = await this.$api.getCode({
						mobile: this.telLoginData.telephone
					});
					if (result) {
						this.$message.success('验证码发送成功');
						this.smsCountDown();
						this.$refs.slideCaptchaRef.reloadSlideCap();
					}
				} catch (err) {
					this.telLoginData.sessionId = null;
					this.$refs.slideCaptchaRef.reloadSlideCap();
				}
			} else {
				this.telLoginData.sessionId = null;
				this.$refs.slideCaptchaRef.reloadSlideCap();
			}
		},
		verifySuccess(value) {
			if (value) {
				this.loginData.sessionId = value.sessionId;
				this.loginData.sig = value.sig;
				this.loginData.scene = this.smartScene;
				this.loginData.token = value.token;
			} else {
				this.loginData.sessionId = null;
				this.$refs.smartCaptchaRef.reloadSmartCaptcha();
			}
		},
		handlerLogin() {
			if (this.loginType === 'password') {
				console.log('账号密码登录');
				this.accountLogin();
			} else {
				console.log('短信验证码登录');
				this.smsLogin();
			}
		},
		//  账号、密码登录
		accountLogin() {
			this.$refs['loginForm'].validate(async valid => {
				if (valid) {
					if (this.loginData.sessionId) {
						try {
							const userInfo = await this.$api.submitLoginInfo({
								account: this.loginData.account,
								password: this.loginData.password,
								session_id: this.loginData.sessionId,
								token: this.loginData.token,
								sig: this.loginData.sig,
								scene: this.loginData.scene
							});
							if (userInfo) {
								this.loginData = {};
								this.mxInitSwitch();
								this.handleUserInfo(userInfo);
								let obj = {};
								obj.id = userInfo.company_id;
								console.log('赋值两个ID-A')
								this.$storage.set('nowCompany', obj);
								this.$storage.set('settlementId', userInfo.settlement_id);
								
								const userInfos = await this.$api.getUserProfile();
								this.$storage.set('is_yichen', userInfo.roles.includes('yichendaodi'));
								this.$storage.set('roles', userInfo.roles);
								this.$storage.set('user_info', userInfos);
								this.$message.success('登录成功');
								this.$refs.smartCaptchaRef.reloadSmartCaptcha();
								console.log(userInfo, '用户信息2');
								this.go();
								console.log(userInfo, '用户信息3');
							} else {
								this.$message.error('登录失败');
								this.$refs.smartCaptchaRef.reloadSmartCaptcha();
								this.initRespErrMsgBoxMark();
							}
						} catch (error) {
							this.$refs.smartCaptchaRef.reloadSmartCaptcha();
							this.loginData.sessionId = null;
							console.log('login error', error);
						}
					} else {
						this.$message.error('请先点击验证按钮开始验证');
					}
				} else {
					this.$message.error('登录失败，请检查必填项数据！');
				}
			});
		},
		//  短信验证码登录

		smsLogin() {
			this.telLogin = true;
			this.$refs['loginFormTel'].validate(async valid => {
				if (valid) {
					if (this.loginData.sessionId) {
						try {
							const userInfo = await this.$api.submitCodeLogin({
								mobile: this.telLoginData.telephone,
								code: this.telLoginData.registerCode,
								session_id: this.loginData.sessionId,
								token: this.loginData.token,
								sig: this.loginData.sig,
								scene: this.loginData.scene
							});
							if (userInfo) {
								this.loginData = {};
								this.mxInitSwitch();
								this.handleUserInfo(userInfo);
								let obj = {};
								obj.id = userInfo.company_id;
								console.log('赋值两个ID-B')
								this.$storage.set('nowCompany', obj);
								this.$storage.set('settlementId', userInfo.settlement_id);
								
								const userInfos = await this.$api.getUserProfile();
								this.$storage.set('is_yichen', userInfo.roles.includes('yichendaodi'));
								this.$storage.set('roles', userInfo.roles);
								this.$storage.set('user_info', userInfos);

								this.$message.success('登录成功');
								this.$refs.smartCaptchaRef.reloadSmartCaptcha();
								this.go();
							} else {
								this.$message.error('登录失败');
								this.loginData.sessionId = null;
								this.$refs.smartCaptchaRef.reloadSmartCaptcha();
								this.initRespErrMsgBoxMark();
							}
						} catch (error) {
							this.$refs.smartCaptchaRef.reloadSmartCaptcha();
							this.loginData.sessionId = null;
							console.log('=========formSubmit', error);
						}
					} else {
						this.$message.error('请先点击验证按钮开始验证');
					}
				} else {
					this.$message.error('登录失败，请检查必填项数据！');
				}
			});
			this.telLogin = false;
		},

		async getVerifiCode() {
			if (!this.telLoginData.telephone) {
				this.$message.error('请先输入手机号');
			} else {
				this.loginType = 'sms';
				this.dialogVisible = true;
			}
		},
		//验证验证码
		async smsVerify() {
			let args = {
				mobile: this.telLoginData.telephone,
				code: this.telLoginData.registerCode
			};
			if (this.telLoginData.sessionId) {
				try {
					let result = await this.$api.smsVerify(args);
					if (result) {
						await this.smsLogin();
					} else {
						this.telLoginData.sessionId = null;
						this.$refs.slideCaptchaRef.reloadSlideCap();
					}
				} catch (err) {
					this.telLoginData.sessionId = null;
					this.$refs.slideCaptchaRef.reloadSlideCap();
				}
			} else {
				this.$message.warning('请先完成验证');
			}
		},
		//  验证码页面的  登录按钮
		handlerSMSLogin() {
			this.$refs['loginFormTel'].validate(valid => {
				if (valid) {
					console.log('ssss', this.telLoginData.sessionId);
					if (this.telLoginData.sessionId) {
						//  校对验证码是否正确
						this.smsVerify();
					} else {
						this.$message.warning('请先获取验证码');
					}
				} else {
					this.$message.error('登录失败，请检查必填项数据！');
				}
			});
		},
		//获取登录用户信息
		async getUserDetail(token) {
			this.$storage.set('jwt', token);
			this.$storage.set('jwtTime', Date.parse(new Date()));
			this.mxInitSwitch();
			let userinfo = await this.$api.getUserDetail();
			console.log('userinfo', userinfo);
			if (userinfo) {
				this.$storage.set('user_info', userinfo);
				this.handleUserInfo(userinfo);
			} else {
				this.$message.error('获取用户信息失败');
			}
		},
		//登录方式
		loginAccount() {
			this.isVisible = true;
			this.isHidden = false;
			this.loginType = 'sms';
		},
		loginTel() {
			this.isVisible = false;
			this.isHidden = true;
			this.loginType = 'password';
		},
		// 路由跳转
		go(url = '/home') {
			this.mxRedirect(url);
		},
		// 初始化响应错误弹窗标志
		initRespErrMsgBoxMark() {
			this.$store.commit('changeRespErrMsgBoxMark', false);
		}
	},
	mounted() {
		this.initRespErrMsgBoxMark();
		if(location.host == 'ayg.jinzhangshi.com'){
			this.loginAccount()
			this.isShowAccountLogin = false
		}
	}
};
</script>

<style lang="stylus" scoped>
.auth-main
	margin 50px 50px 50px 50px
.input-item
	margin-bottom 32px !important
.el-checkbox
	color white !important
.login-input .el-input__inner
	height 50px
.el-tabs__nav-wrap::after
	height 0px
.el-tabs__nav
	display inline-block
	float none
.el-tabs__header
	text-align center
.el-input__prefix
	left 8px
.el-tabs__header
	margin-bottom 24px
.login-button
	width 100%
	height 50px
	margin-top 15px
	border none
.login-button:hover
	background #48B4FF
.el-checkbox
	.el-checkbox, .el-checkbox__input.is-checked + .el-checkbox__label
		color #000000 !important
	#tab-login2
		height 0px
	.get-register
		width 120px
	.el-form-item
		margin-bottom 5px
	.el-form-item__conten
		height 50px
	.login-way
		font-size 14px
		color #606266
	.login-wrapper
		margin-top -25px
	.remember
		color #757575
	.password
		display flex
		flex-direction row
		justify-content space-between
		margin-top 30px
>>>.nc_wrapper
	margin 0 auto
>>>.el-dialog__body
	padding-bottom 50px
</style>
